import React, { lazy, Suspense, useState, useEffect } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '../utils/webpack/chunkRetry';

const VideoPlayerLazy = lazy(() =>
  retry(() => import(/* webpackChunkName: "playable" */ 'react-playable'))
);

export interface Props {
  src: string;
  className?: string;
  autoPlay?: boolean;
  muted?: boolean;
  fillAllSpace?: boolean;
  loadingCover?: string;
  onInit?: any;
  width?: number;
  height?: number;
}

export const VideoPlayer: React.FC<Props> = ({
  width,
  height,
  src,
  className,
  autoPlay,
  muted,
  loadingCover,
  fillAllSpace,
  onInit,
}) => {
  const [mounted, setMounted] = useState<boolean>(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const onPlayerInit = (player: any) => {
    // Disable picture in picture feature control.
    // Fullscreen affects devpage's own fullscreen so it's disabled as well.
    player.hidePictureInPictureControl();
    player.hideFullScreenControl();
    onInit && onInit(player);
  };

  return (
    <ErrorBoundary debugComponent="VideoPlayer">
      {mounted && (
        <Suspense fallback={<LoadingIndicator coverMode />}>
          <div className={className}>
            <VideoPlayerLazy
              src={src}
              autoplay={autoPlay}
              muted={muted}
              fillAllSpace={fillAllSpace}
              poster={loadingCover}
              onInit={onPlayerInit}
              width={width}
              height={height}
            />
          </div>
        </Suspense>
      )}
      <noscript>
        <video width={width || 640} height={height || 480} controls src={src} />
      </noscript>
    </ErrorBoundary>
  );
};
VideoPlayer.displayName = 'VideoPlayer';
